import React, { createContext, useState } from 'react';

export const CreateModalContext = createContext({
    isOpen: false,
    openCreateModal: () => {},
    closeCreateModal: () => {},
});

export const CreateModalProvider = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);

    const openCreateModal = () => {
        setIsOpen(true);
    };

    const closeCreateModal = () => {
        setIsOpen(false);
    };

    return (
        <CreateModalContext.Provider
            value={{
                isOpen,
                openCreateModal,
                closeCreateModal,
            }}
        >
            {children}
        </CreateModalContext.Provider>
    );
};

